<template>
  <div style="height: 100%; background-color: #fff">
    <template v-if="btnShow">
      <a-button
        @click="back"
        style="color: #1abc9c; border-color: #1abc9c; margin-bottom: 10px"
      >
        返回
      </a-button>
      <div
        style="display: inline-block; margin-left: 16px"
        v-if="readOnly == 'false'"
      >
        <a-button @click="saveDoc(0)"> 保存 </a-button>
        <a-button type="primary" style="margin-left: 16px" @click="saveDoc(1)">
          提交
        </a-button>
        <span style="margin-left: 16px"> 使用Ctrl + S 保存修改文档 </span>
      </div>
    </template>
    <div id="viewFile" :style="{ height: btnShow ? '95%' : '100%' }"></div>
  </div>
</template>
<script>
import WebOfficeSDK from "@/assets/js/web-office-sdk-solution-v1.1.27.es";
let wpsInstance;
let wpsApp;
export default {
  name: "ShowWpsFile",
  props: {
    btnShow: {
      type: Boolean,
      default: true,
    },
    fileCode: {
      type: String,
      default: "",
    },
    isReadOnly: {
      type: String,
      default: "true",
    },
  },
  data() {
    return {
      fileId: "",
      readOnly: "true",
    };
  },
  mounted() {
    this.fileId = this.$route.query.fileCode || this.fileCode;
    const readOnly = this.$route.query.readOnly;
    this.readOnly = readOnly || this.isReadOnly;
    this.openWps();
  },
  methods: {
    // 获取web预览文件地址
    async openWps() {
      let _this = this;
      wpsInstance = WebOfficeSDK.init({
        officeType: WebOfficeSDK.OfficeType.Writer,
        appId: _this.$config.wpsAppId,
        fileId: _this.fileId,
        token: "CCSJiXMpPIibHJxDaJPa",
        mount: "#viewFile",
        customArgs: {
          userCode: sessionStorage.getItem("userCode"),
          readOnly: _this.readOnly,
          appKey: _this.$config.appKey,
        },
        wordOptions: {
          isShowDocMap: false, // 是否开启目录功能，默认开启
          isBestScale: false, // 打开文档时，默认以最佳比例显示
          isShowBottomStatusBar: false, // 是否展示底部状态栏
        },
      });
      await wpsInstance.ready();
      wpsApp = wpsInstance.Application;
      if (_this.readOnly != "true") {
        const ReviewTrackChanges = await wpsApp.CommandBars(
          "ReviewTrackChanges"
        );
        setTimeout(async () => {
          await ReviewTrackChanges.Execute();
        }, 200);
      }
    },
    saveDoc(type) {
      // 0 保存 1 提交
      wpsInstance.save();
      if (type == 0) {
        this.utils.messageInfo(this, "success", "保存成功");
      }
      if (type == 1) {
        this.axios
          .post("/manuscripts/updateManuscripts", {
            code: this.fileId,
            status: 2,
            result: 0,
            type: 1,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "提交成功");
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
